import {ServicesService} from 'services/servicesService';
import {createEntityThunks} from 'utils/createEntityThunks';
import {Service} from 'types/service';

const serviceFactory = (data: any) => new Service(data);

export const ServicesThunks = createEntityThunks<Service>(
  'service',
  ServicesService,
  {activate: true, deactivate: true},
  serviceFactory,
);
